export default __webpack_public_path__ + "1ca59302fe2641f820dd0dfb5986dcbe.svg";